import * as types from './types'
import _ from 'underscore'

const mutations = {
  [types.SETAPPWEB]: (state, data) => {
    state.appweb = data
  },
  [types.SETMATCH]: (state, data) => {
    state.match = data
  },
  [types.SETGAMEID]: (state, data) => {
    state.gameId = data;
  },
  [types.SETMENUNAME]: (state, data) => {
    state.menuname = data;
  },
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js